export default "__VITE_ASSET__CyUwvGuI__"